import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { merchantsType } from "../promotionServiceAgreement/index";
import './index.less';

function cluesText(type, date) {
    let curDate;
    let newDate = new Date(date);
    let Y = newDate.getFullYear();
    let M = newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
    let D = newDate.getDate() < 10 ? ('0' + newDate.getDate()) : newDate.getDate();
    curDate = `${Y}年${M}月${D}日`;
    switch (type) {
        case merchantsType.拒绝签署商户:
            return `您已拒绝与平台续签协议，原协议于<span style="color:#1890FF">${date ? curDate : ''}</span>到期，到期后将无法出新单，历史保单可进行续期续保及提现，如有问题请联系您的商务伙伴。`;
        case merchantsType.历史团队版商户:
            return `根据平台要求，请您在<span style="color:#1890FF">${date ? curDate : ''}</span>前确认团队协议内容并签名，否则将无法出新单，历史保单可进行续期续保及提现，感谢您的配合。`;
        case merchantsType.公转私商户:
            return `根据平台要求，请您确认团队协议内容并签名，否则将无法出新单，历史保单可进行续期续保及提现，感谢您的配合。`;
        case merchantsType.协议到期商户:
            return `您的团队协议将在<span style="color:#1890FF">${date ? curDate : ''}</span>到期，请尽快确认是否同意协议续签，过期将无法出新单，历史保单可进行续期续保及提现，感谢您的配合。`;
        case 'inactive':
            return `<span style="color:#4276f2">由于您长时间未活跃，已暂停部分服务</span>`;
    }
}

function PromptSceneBar(prop) {
    const { show, isConfirm, clickConfirm, type, date, children } = prop;
    return (
        <React.Fragment>
            {
                show && <div className='text'>
                    <p><InfoCircleFilled style={{'color':'#1890FF'}} />&nbsp;&nbsp;<span style={{'color': '#323233'}} dangerouslySetInnerHTML={{__html:cluesText(type, date)}}></span><span style={{'color': '#1890FF','cursor': 'pointer'}} onClick={() => { clickConfirm() }}>{isConfirm ? '去确认>>' : ''}</span></p>
                </div>
            }
        </React.Fragment>
    )
}
PromptSceneBar.propTypes = {
    show: PropTypes.bool.isRequired,
    isConfirm: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    date: PropTypes.string,
    clickConfirm: PropTypes.func,
};
export default PromptSceneBar;
